export const BACKGROUND_BANNER_IMAGES = {
    sm: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/af05dafff46bc796c82606a12ad2765d-1758298032998/mobiile_banner_orig.png',
    md: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/b1d3fd3caa35145ebb826842a3a50db8-1754303210311/1920-900_HP%20Banner.svg',
} as const;
